import { provideRouter } from '@angular/router';
import { OrganizationManagementRoutes } from './organization-management.routing';
import { OrganizationService } from '../../shared/services/organization.service';
import { OrganizationFacade } from '../../shared/state/organization/facades/organization.facade';

export const organizationManagementConfig = [
  provideRouter(OrganizationManagementRoutes),
  OrganizationService,
  OrganizationFacade,
];

